<template>
  <my-dialog
    @hideMask="$emit('handleContactCustomerServiceDialogClose')"
    :dialogFlag="contactCustomerServiceDialogFlag"
    width="300px"
    p_lr="0"
    :clickMaskForHide="true"
  >
    <div class="dialog_inner_container_for_show_phone">
      <div class="dialog_inner_container_for_show_phone_header">
        联系智慧树运维
      </div>
      <div class="dialog_inner_container_for_show_phone_content">
        <div class="dialog_inner_container_for_show_phone_content_top">
          <p>拨打智慧树</p>
          <p>运维客服电话</p>
        </div>
        <div class="dialog_inner_container_for_show_phone_content_bottom">
          {{ phoneNumber ? phoneNumber : '- -' }}
        </div>
      </div>
      <div class="dialog_inner_container_for_show_phone_footer">
        <!-- <div class="dialog_inner_container_for_show_phone_footer_inner_button ZHIHUISHU_QZMD" @click="$emit('handleContactCustomerServiceDialogClose')">
          确定
        </div> -->
        <a-button type="primary" @click="$emit('handleContactCustomerServiceDialogClose')">
          确定
        </a-button>
      </div>
    </div>
  </my-dialog>
</template>

<script>
export default {
  name: 'contactCustomerService',
  components: {
    'my-dialog': () => import('@/components/my_dialog')
  },
  data () {
    return {
      phoneNumber: ''
    }
  },
  props: {
    contactCustomerServiceDialogFlag: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async getPhoneNumber() {
      try {
        this.dialogFlagForShowPhone = true
        const result = await this.$http.getStaffPhone()
        if (result.code !== 200) return this.$message.error(result.msg)
        const { rt: resultReally } = result
        if (resultReally.resultStatus !== 1) return this.$message.error(resultReally.resultMessage ? resultReally.resultMessage : '获取电话失败')
        this.phoneNumber = resultReally.tel
      } catch(err) {
        console.log(err);
      }
    }
  },
  async created () {
    await this.getPhoneNumber()
  }
}
</script>

<style lang="scss" scoped>
  @mixin dialogTitle($color) {
    width: 100%;
    height: 60px;
    line-height: 60px;
    font-weight: bold;
    color: $color;
    font-size: 16px;
    border-radius: 10px 10px 0 0;
    padding: 0 30px;
    border-bottom: 1px solid #E7E7E7;
  }
  @mixin verticalAndCrosswiseCenter {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .dialog_inner_container_for_show_phone {
    height: auto;
    border-radius: 10px;
    .dialog_inner_container_for_show_phone_header {
      @include dialogTitle(#222);
    }
    .dialog_inner_container_for_show_phone_content {
      .dialog_inner_container_for_show_phone_content_top {
        width: 100%;
        height: 80px;
        @include verticalAndCrosswiseCenter();
        flex-direction: column;
      }
      .dialog_inner_container_for_show_phone_content_bottom {
        width: 100%;
        height: 50px;
        font-size: 24px;
        @include verticalAndCrosswiseCenter();
        color: #5F60D3;
        font-weight: bold;
      }
    }
    .dialog_inner_container_for_show_phone_footer {
      width: 100%;
      height: 70px;
      @include verticalAndCrosswiseCenter();
      align-items: flex-start;
      padding-top: 5px;
      .ant-btn-primary{
        width: 104px;
        height: 38px;
        background-color: #5F60D3;
        border-color: #5F60D3;
        &:hover{
          opacity: 0.9;
          color: #fff;
        }
      }
      // .dialog_inner_container_for_show_phone_footer_inner_button {
      //   width: 80px;
      //   height: 32px;
      //   background-color: #FFF;
      //   border: 1px solid #D9D9D9;
      //   color: #595959;
      //   @include verticalAndCrosswiseCenter();
      //   border-radius: 5px;
      //   cursor: pointer;
      //   font-size: 14px;
      //   letter-spacing: 2px;
      //   transition: all 0.5s;
      //   &:hover {
      //     border: 1px solid #2090FF !important;
      //     color: #2090FF !important;
      //   }
      // }
    }
  }
</style>